export function injectConsentChain() {
  const url = import.meta.env.VITE_OSANO_SCRIPT_URL;

  const consent = document.createElement("script");
  consent.id = "consent-default";
  consent.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent','default',{
      'ad_storage':'denied','analytics_storage':'denied',
      'ad_user_data':'denied','ad_personalization':'denied',
      'personalization_storage':'denied','functionality_storage':'granted',
      'security_storage':'granted','wait_for_update':500
    });
    gtag("set","ads_data_redaction",true);
    gtag("set","url_passthrough",true);
  `;
  document.head.appendChild(consent);

  if (url && !document.getElementById("osano-script-loader")) {
    const osano = document.createElement("script");
    osano.id = "osano-script-loader";
    osano.src = url;
    osano.async = false;
    document.head.appendChild(osano);
  }

  const gtmBootstrapScript = document.createElement("script");
  gtmBootstrapScript.id = "gtm-bootstrap";
  gtmBootstrapScript.src = "/scripts/gtm.js";
  gtmBootstrapScript.async = true;
  document.head.appendChild(gtmBootstrapScript);
}
